import ReactDOM from 'react-dom';

import {  Modal } from 'antd';
import { useEffect, useState } from 'react';
import  FormLogin  from './FormLogin';
import FormRegister from './FormRegister';


export const ModalFormLogin = ({
  setModo
}) => {
  const [isOpen, setIsOpen] = useState(true)
  const [isRegister, setIsRegister] = useState(false)

  const handleCloseModal = (e) => {    
    //e.preventDefault()    
    setIsOpen(false)
  }

  const handleOnCancel = () => {
    setModo(true);
    setIsOpen(false)
  }

  const bgColor = "rgba(7, 21, 41, 0.7)";

  

  return ReactDOM.createPortal(    
        
          <Modal            
           open={isOpen}       
           onCancel={handleOnCancel}
           styles={{
            content: {
              backgroundColor: bgColor,
              color: 'white',
            },
           header: {
              backgroundColor: bgColor,
              color: 'white',
              marginBottom: '20px'
            }
            
            }}
            footer={[              
            ]}
            closable={false}
            maskClosable={false}
            >
              {isRegister ? <FormRegister handleCloseModal={handleCloseModal} setIsRegister={setIsRegister}/> : <FormLogin handleCloseModal={handleCloseModal} setIsRegister={setIsRegister}/>}

              
            </Modal>
        
    ,document.getElementById('modal')
  )
}
